import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=7dfbe8da&scoped=true&"
import script from "./Student.vue?vue&type=script&lang=js&"
export * from "./Student.vue?vue&type=script&lang=js&"
import style0 from "./Student.vue?vue&type=style&index=0&id=7dfbe8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfbe8da",
  null
  
)

export default component.exports